import * as React from 'react';
import { getQueryStringParams,SearchSelect, SearchInput} from "../../../common";
import API from "../../../common/AxoisClient";
const moment = require('moment');

interface IState {
  form: {
    like: {
        name: string,
        type: string,
    },
    equal: {
        status: number,
        is_default:number
    }
},
    typeOptions: string[]
 }

export default class CompanyFilter extends React.Component<any, IState> {
  state: IState;

  UNSAFE_componentWillMount() {
    let old_data: any = getQueryStringParams("form");
    old_data = JSON.parse(old_data);
    this.setState({
      form: {
        like: {
          name: old_data ? old_data.like.name : "",
          type: old_data ? old_data.like.type : "",
        },
        equal: {
          status: old_data ? old_data.equal.status : "",
          is_default: old_data ? old_data.equal.is_default : "",
        },
      },
      typeOptions: [],
    });
    API.get("settings/email-templates/types")
      .then((response) => {
        this.setState({ typeOptions: response.data });
      })
      .catch((error) => {
        console.error("Error fetching email template types:", error);
      });
  }

  handleInputForm = (e: React.ChangeEvent<HTMLInputElement>) => {
    let name = e.target.name.split(".");
    let newAccess: any = Object.assign({}, this.state.form);
    newAccess[name[1]][name[2]] = e.target.value;
    this.setState({form: newAccess},() =>  this.props.getResults(this.state.form));
  }

  

  render(){
   return (
      <div className="row align-items-center">
 
 <SearchInput name={'form.like.name'} value={this.state.form.like.name} placeholder={'Enter name'} onChange={this.handleInputForm}  />
  <SearchSelect name={'form.equal.is_default'} value={this.state.form.equal.is_default} onChange={this.handleInputForm} options={[{ label: "Select Template", value: "" },{ label: "System Template", value: 1 },{ label: "Custom Template", value: 0 }]}/>
  <SearchSelect name="form.like.type" value={this.state.form.like.type} onChange={this.handleInputForm}
  options={[{ label: "Select Type", value: "" }, ...this.state.typeOptions.map(type => ({ label: type, value: type }))]}/>
  <SearchSelect name={'form.equal.status'} value={this.state.form.equal.status} onChange={this.handleInputForm} options={[{'label': "Select Status", "value": ""}, {'label': "Active", "value": 1}, {'label': "Inactive", "value": 2}]}/></div>
)
  }
}